// extracted by mini-css-extract-plugin
export default {"wrapper":"h6-z","play":"i6-z"};